var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#212121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.415 30.416 13-13.005c.377-.376.587-.878.587-1.411s-.207-1.035-.586-1.411L17.415 1.584a1.987 1.987 0 0 0-1.412-.586c-.532 0-1.035.207-1.411.586L1.587 14.59A1.987 1.987 0 0 0 1.002 16c0 .533.206 1.035.585 1.411l13.005 13.005c.376.376.879.586 1.411.586.533 0 1.035-.207 1.412-.586z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.53 29.474 2.527 16.469a.686.686 0 0 1 0-.942l13.005-13c.26-.26.682-.26.942 0l13 13a.66.66 0 0 1 0 .94L16.47 29.47a.667.667 0 0 1-.942 0l.004.003z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#212121",
    transform: "rotate(90 15.002 16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 21
  }, "Y")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapNode);
export default __webpack_public_path__ + "static/media/map-node.d63991cc1cc07a1defafa1186b98f92a.svg";
export { ForwardRef as ReactComponent };